import classNames from 'classnames';
import { CSSProperties, FC, PropsWithChildren } from 'react';

import * as Styles from './message-bubble.module.less';

interface MessageBubbleProps {
    isMine: boolean;
    showBubble?: boolean;
    style?: CSSProperties;
    className?: string;
}

export const MessageBubble: FC<PropsWithChildren<MessageBubbleProps>> = ({
    isMine,
    children,
    showBubble = true,
    style,
    className,
}) => {
    return (
        <div
            style={style}
            className={classNames(
                {
                    [Styles.messageBubble]: showBubble,
                    [Styles.messageBubbleMine]: isMine && showBubble,
                    [Styles.messageBubbleChatbot]: !isMine && showBubble,
                },
                className
            )}
        >
            {children}
        </div>
    );
};
